import React from "react";
import { DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import clsx from "clsx";
type Props = {
  children: React.ReactNode;
  heading: string;
  isWide?: boolean;
  headerComponent?: React.ReactNode;
  className?: string;
  /** Extra classes for the scrollable body wrapper. */
  bodyClassName?: string;
  showCloseButton?: boolean;
  closeOnOutsideClick?: boolean;
};

const MyDialogContent = ({
  showCloseButton = true,
  closeOnOutsideClick = false,
  children,
  heading,
  isWide = false,
  headerComponent,
  className,
  bodyClassName,
}: Props) => {
  const hasHeading = Boolean(heading?.trim());

  return (
    <DialogContent
      showCloseButton={showCloseButton}
      closeOnOutsideClick={closeOnOutsideClick}
      className={clsx(
        "max-w-2xl",
        !!isWide
          ? "sm:max-w-[80dvw] w-full h-[70vh]"
          : "w-[96dvw] sm:max-w-2xl md:w-3xl md:max-w-3xl max-h-[90vh]  ",
        " flex flex-col gap-4 p-0 pb-4",
        className,
      )}
    >
      {hasHeading ? (
        <DialogHeader className="shrink-0 p-4 pb-0">
          <DialogTitle>{heading}</DialogTitle>
          {headerComponent && headerComponent}
        </DialogHeader>
      ) : null}
      <div
        className={clsx(
          "min-h-0 flex-1 overflow-y-auto p-4 pb-0",
          bodyClassName,
        )}
      >
        {children}
      </div>
    </DialogContent>
  );
};

export default MyDialogContent;
